import { ArrowRight } from "lucide-react";
import Reveal from "../Reveal";
import { CONTACT, FREE_EDIT_LABEL } from "../../data/site";

export const FinalCta = () => (
  <section data-testid="final-cta" className="bg-[#C8F031] section-pad">
    <div className="container-x text-center">
      <Reveal>
        <p className="font-heading text-[11px] sm:text-xs font-bold uppercase tracking-[0.28em] text-black/50">
          Free. No strings.
        </p>
        <h2 className="mt-5 mx-auto max-w-3xl font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight leading-[1.02] text-black">
          Send us 30 seconds of your footage. See what comes back.
        </h2>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            data-testid="cta-free-edit-btn"
            href={CONTACT.freeEditLink}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-black text-white font-heading font-bold text-sm px-8 rounded-full transition-colors duration-200 hover:bg-[#1a1a1a] min-h-[48px] w-full sm:w-auto"
          >
            {FREE_EDIT_LABEL} <ArrowRight className="w-4 h-4" />
          </a>
          <a
            data-testid="cta-whatsapp-btn"
            href={CONTACT.whatsappLink}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center justify-center gap-2 bg-transparent border-2 border-black text-black font-heading font-bold text-sm px-8 rounded-full transition-colors duration-200 hover:bg-black hover:text-[#C8F031] min-h-[48px] w-full sm:w-auto"
          >
            Just say hi on WhatsApp
          </a>
        </div>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-8">
          <a
            data-testid="cta-email-btn"
            href={`mailto:${CONTACT.email}`}
            className="font-heading text-sm font-semibold text-black/60 hover:text-black transition-colors min-h-[44px] inline-flex items-center"
          >
            {CONTACT.email}
          </a>
          <a
            data-testid="cta-call-btn"
            href={`tel:${CONTACT.phone}`}
            className="font-heading text-sm font-semibold text-black/60 hover:text-black transition-colors min-h-[44px] inline-flex items-center"
          >
            {CONTACT.phoneDisplay}
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);

export default FinalCta;
